import { useContext, useEffect } from "react";
import { SearchVehicleByVinDataContext } from "../SearchVehicleByVinDataProvider";
import { LoadingData, SearchVehicleDataContextType, SetSearchVehicleDataContextType } from "../types";
import { carVehicleDataRequest } from "@/utils/requests/laximo/carVehicleDataRequest";

/**
 * Загрузка параметров поиска автомобиля
 * @param {React.ReactNode} children - Дочерние компоненты
 * @returns {React.ReactNode}
 */
export const LoadVehicleByParams = ({ children }: { children: React.ReactNode }) => {
    const { vehicleId, catalog, ssd, setIsLoading, setError, setVehicle } = useContext(SearchVehicleByVinDataContext) as SearchVehicleDataContextType & SetSearchVehicleDataContextType & LoadingData;

    useEffect(() => {
        if (vehicleId && catalog && ssd) {
            setIsLoading(true);
            carVehicleDataRequest(vehicleId, catalog, ssd)
                .then(data => {
                    setVehicle(data);
                })
                .catch(error => {
                    setError(error.message);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [vehicleId, catalog, ssd]);

    return children;
};